export enum NotificationSeverity
{
    info = 0,
    success = 1,
    warning = 2,
    error = 3
}
